<div class="workshop-jobcard-header">
    <div class="workshop-jobcard-header-row" [ngClass]="{'manage-jobcard': jobcard.id > 0}">
        <div>
            <!-- <hub-button [icon]="'arrow-left'" [size]="'xl'" [style]="'outline'" (buttonClick)="activeModal.close()">
            </hub-button> -->
            <div *ngIf="jobcard.id === null || jobcard.id === undefined" class="workshop-header-text">
                {{'bikeshop.workshop.jobcard.create_title' | translate}}</div>
            <div *ngIf="jobcard.id === -1" class="workshop-header-text">
                {{'bikeshop.modal.update_job_card.job_card.linked_job_cards' | translate}}</div>
            <div *ngIf="jobcard.id > 0" class="workshop-header-text customer-details-container"
                (click)="updateCustomer()">
                <span *ngIf="getCustomerName() === ''">{{'bikeshop.workshop.jobcard.manage_title' | translate}}</span>
                <div>
                    <span class="customer-name" *ngIf="getCustomerName() !== ''">{{getCustomerName()}}</span>
                    <div class="customer-details">
                        <span>{{jobcard.customer?.Email}}</span>
                        <span *ngIf="jobcard.customer?.Email && jobcard.customer?.PhoneNumber"
                            style="margin-left: 8px;margin-right:8px;">|</span>
                        <span>{{jobcard.customer?.PhoneNumber}}</span>
                    </div>
                </div>
            </div>
            <!--<div class="locked-banner" *ngIf="isLocked && jobcard.id > 0">
                <daz-icon [name]="'lock'" [size]="'16px'" [color]="'#6D6D6D'"></daz-icon>
                <span>{{'bikeshop.workshop.jobcard.locked_banner' | translate}}</span>
            </div>-->
        </div>
        <div>
            <div *ngIf="jobcard.id > 0">
                <div class="jobcard-info">
                    <span *ngIf="jobcard.statusID >= 40" class="status">{{getCurrentStatusLabel()}}</span>
                    <span *ngIf="jobcard.statusID >= 40">|</span>
                    <span class="jobcard-no">#{{jobcard.jobCardNo}}</span>
                </div>
                <div class="jobcard-details" (click)="openBookingDetails()"
                    *ngIf="jobcard.scheduleDate || jobcard.technicianName || (jobcard.selectedServiceTypes && jobcard.selectedServiceTypes.length > 0)">

                    <div
                        *ngIf="jobcard.collectionsDeliveries?.allowCollection && jobcard.collectionsDeliveries?.collectionInfo?.scheduleDate && jobcard.statusID < 40">
                        <daz-icon [name]="'truck'" [size]="'18px'" [color]="'#6b39c8'"></daz-icon>
                        <span>{{jobcard.collectionsDeliveries.collectionInfo.scheduleDate | date:
                            countryData?.AngularDateFormat}}</span>
                    </div>
                    <div
                        *ngIf="jobcard.collectionsDeliveries?.allowDelivery && jobcard.collectionsDeliveries?.deliveryInfo?.scheduleDate && jobcard.statusID > 40 && jobcard.statusID != 100">
                        <daz-icon [name]="'truck'" [size]="'18px'" [color]="'#6b39c8'"></daz-icon>
                        <span>{{jobcard.collectionsDeliveries.deliveryInfo.scheduleDate | date:
                            countryData?.AngularDateFormat}}</span>
                    </div>
                    <div>
                        <daz-icon [name]="'calendar-day'" [size]="'18px'" [color]="'#6b39c8'"></daz-icon>
                        <span>{{jobcard.scheduleDate | date: countryData?.AngularDateFormat + ' h:mma'}}</span>
                    </div>
                    <div>
                        <daz-icon [name]="'clipboard-user'" [size]="'18px'" [color]="'#6b39c8'"></daz-icon>
                        <span>{{jobcard.technicianFullName}}</span>
                    </div>
                    <div *ngIf="jobcard.thirdPartyID && jobcard.thirdPartyName">
                        <daz-icon [name]="'link-alt-1'" [size]="'18px'" [color]="'#6b39c8'"></daz-icon>
                        <span>{{jobcard.thirdPartyName}}</span>
                    </div>
                    <div *ngIf="jobcard.bayNo">
                        <daz-icon [name]="'tag'" [size]="'18px'" [color]="'#6b39c8'"></daz-icon>
                        <span>{{jobcard.bayNo}}</span>
                    </div>
                    <div *ngIf="jobcard.createdByName?.length > 1">
                        <daz-icon [name]="'user-check-alt'" [size]="'18px'" [color]="'#6b39c8'"></daz-icon>
                        <span>{{jobcard.createdByName}}</span>
                    </div>
                    <div *ngIf="jobcard.checkedByName?.length > 1">
                        <daz-icon [name]="'search'" [size]="'18px'" [color]="'#6b39c8'"></daz-icon>
                        <span>{{jobcard.checkedByName}}</span>
                    </div>
                    <div>
                        <daz-icon [name]="'settings-gear'" [size]="'18px'" [color]="'#6b39c8'"></daz-icon>
                        <span>{{getServiceTypesLabel()}}</span>
                    </div>
                </div>
            </div>
            <hub-button class="reset-form-button" *ngIf="!jobcard.id"
                text="{{'bikeshop.modal.shedule_service.reset_form' | translate}}" [icon]="'refresh-ccw'" [size]="'xl'"
                [style]="'outline'" [disabled]="!hasChanged()" (buttonClick)="resetForm()">
            </hub-button>
            <!-- <hub-button [icon]="'print'" [size]="'xl'" [style]="'outline'" [disabled]="!allowPrinting">
            </hub-button>
            <hub-button [icon]="'gear'" [size]="'xl'" [style]="'outline'" [disabled]="!allowSettings">
            </hub-button> -->
            <hub-button id="close-jobcard-button" class="lock-exempt" [icon]="'cross'" [size]="'xl'" [style]="'outline'"
                (buttonClick)="activeModal.dismiss()">
            </hub-button>
        </div>
    </div>
</div>
